<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Scopes
      <div slot="right">
        <b-button
          v-if="isEditAllowed"
          type="is-primary import-button"
          @click="clickAddScope"
          >+ &nbsp;Add Scope</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <circul8-table
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="true"
        :maxTextLength="'24'"
        :isLoading="isDataLoading"
        :backendSortingEnabled="true"
        @clickEdit="clickEditScope"
        @clickView="clickViewScope"
        @backendSort="sortData"
        :showRemoveButton="isEditAllowed"
        :showEditButton="true"
        :routeNext="false"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        @clickDelete="deleteModal"
        :saveDataFields="true"
        :tableName="tblName"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + data.length
                : totalRecords
              : data.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
    <add-scopes
      :is-active="isModalActive"
      :view-only="viewOnly"
      :action="action"
      :form="editObjectName"
      @confirm="addScope"
      @cancel="editCancel"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import RulesManagerService from "../../services/RulesManagerService";
import AddScopes from "@/components/RulesManager/AddScopes.vue";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import CountryDataService from "@/services/CountryDataService";
import ContainerDataService from "@/services/ContainerDataService";
import SchemeDataService from "@/services/SchemeDataService";
import ScopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";

export default {
  name: "Scopes",
  mixins: [UtilityMixin, ScopeMixin],
  components: { HeroBar, TitleBar, Circul8Table, AddScopes },
  data() {
    return {
      tblName: "ScopesListView",
      schemes: [],
      data: [],
      isDataLoading: false,
      isModalActive: false,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      columns: [
        {
          field: "country_name",
          label: "Country",
          searchable: true,
          searchKey: "country_name",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country_name: "", field_name: "name" }
        },

        {
          field: "scheme_name",
          label: "Scheme",
          type: "multiSelectFilter",
          searchable: true,
          filterKey: { scheme_name: "", field_name: "name" },
          allStatusVals: this.schemes,
          searchKey: "scheme_name"
        },
        {
          field: "stream_name",
          label: "Stream",
          searchable: true,
          type: "multiSelectFilter",
          filterKey: { stream_name: "", field_name: "name" },
          initStatusVals: [],
          allStatusVals: this.containers,
          searchKey: "stream_name"
        },

        {
          field: "total_rules_applied",
          label: "Total Rules Applied",
          searchable: true,
          filterKey: { total_rules_applied: "" },
          type: "input",
          width: "250"
        },

        {
          field: "valid_from",
          label: "Valid From",
          searchable: true,
          filterKey: { valid_from: "" },
          type: "dateField"
        },
        {
          field: "valid_to",
          label: "Valid To",
          searchable: true,
          filterKey: { valid_to: "" },
          type: "dateField"
        },
        {
          field: "status",
          label: "Status",
          searchable: true,
          visible: true,
          searchKey: "status",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "comment_for_rejection",
          initStatusVals: [],
          allStatusVals: [
            { name: "Draft" },
            { name: "Sent for Approval" },
            { name: "Raw data received" },
            { name: "Approved" },
            { name: "Rejected" }
          ],
          filterKey: {
            status: [],
            field_name: "name"
          }
        },
        {
          field: "updated_at",
          label: "Last Updated",
          searchable: true,
          filterKey: { updated_at: "" },
          type: "dateField"
        },
        {
          field: "updated_by_name",
          label: "Updated By",
          searchable: true,
          filterKey: { updated_by_name: "" },
          type: "input"
        },

        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      RulesManagerService: new RulesManagerService(),
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService()
    };
  },
  mounted() {
    this.fetchCountries();
    this.checkExternalPermission();
    this.fetchContainers();
    this.fetchSchemes();
    if (localStorage.getItem(this.tblName + "SaveDataFields")) {
      this.columns = JSON.parse(
        localStorage.getItem(this.tblName + "SaveDataFields")
      );
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }
    if (localStorage.getItem(this.tblName + "Query")) {
      this.query = `${localStorage.getItem(this.tblName + "Query")}&`;
    }
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rule Manager" },
        { url: "/ruleManager/scope", name: "Scopes" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    countries: {
      handler: function(value) {
        value && value.length > 0 ? this.fetchScopeData(this.query) : "";
      },
      immediate: true
    }
  },
  methods: {
    convertDateStringToObject() {
      const valid_from = this.find_column_index("valid_from");
      if (this.columns[valid_from].filterKey.valid_from.length) {
        this.columns[valid_from].filterKey.valid_from[0] = new Date(
          this.columns[valid_from].filterKey.valid_from[0]
        );
        this.columns[valid_from].filterKey.valid_from[1] = new Date(
          this.columns[valid_from].filterKey.valid_from[1]
        );
      }

      const valid_to = this.find_column_index("valid_to");
      if (this.columns[valid_to].filterKey.valid_to.length) {
        this.columns[valid_to].filterKey.valid_to[0] = new Date(
          this.columns[valid_to].filterKey.valid_to[0]
        );
        this.columns[valid_to].filterKey.valid_to[1] = this.convertToDateObject(
          this.columns[valid_to].filterKey.valid_to[1]
        );
      }

      const updated_at = this.find_column_index("updated_at");
      if (this.columns[updated_at].filterKey.updated_at.length) {
        this.columns[updated_at].filterKey.updated_at[0] = new Date(
          this.columns[updated_at].filterKey.updated_at[0]
        );
        this.columns[
          updated_at
        ].filterKey.updated_at[1] = this.convertToDateObject(
          this.columns[updated_at].filterKey.updated_at[1]
        );
      }
    },
    convertToDateObject(date) {
      if (date) {
        return new Date(date);
      }
    },
    find_column_index(column_name) {
      if (this.columns) {
        return this.columns.findIndex(col => col.field === column_name);
      }
      return null;
    },
    prepareMasterData(data) {
      const allStatusVals = [];
      data.forEach(element => {
        allStatusVals.push({ name: element.name });
      });

      return allStatusVals;
    },
    getClearFormObject() {
      return {
        id: null,
        country: null,
        scheme: null,
        stream: null
      };
    },
    clickAddScope() {
      this.viewOnly = false;
      this.action = "Add";
      this.isAdd = true;
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },

    addScope(editObject) {
      this.$router.push({
        name: "rulesManager.scopeDefinition",
        params: { formData: editObject, isAdd: true, isViewOnly: false }
      });
    },

    editCancel() {
      this.isModalActive = false;
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["actions"] = this.isEditAllowed;
        reportData["delete"] = this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      this.columns[0].allStatusVals = this.countries;
      this.columns[1].allStatusVals = this.schemes;
      this.columns[2].allStatusVals = this.containers;
      this.isDataLoading = false;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchScopeData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchScopeData(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchScopeData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchScopeData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchScopeData(query = "", scrollDir) {
      this.isDataLoading = true;
      this.isLoading = true;
      this.RulesManagerService.getScopeData(query).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            //this.totalRecords = this.data.length + response["count"];
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"], scrollDir);
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
          this.isLoading = false;
          this.nextData = false;
        }
      );
    },

    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Scope",
        message: "Are you sure you want to <b>delete</b> this Scope?",
        confirmText: "Delete Scope",
        type: "is-danger",
        onConfirm: () => this.deleteScope(editObject)
      });
    },
    deleteScope(editObject) {
      try {
        this.RulesManagerService.deleteScope(editObject).subscribe(
          response => {
            let reports = "";
            let msg = "";
            if (response.message) {
              if (
                response.report_definitions &&
                response.report_definitions.length > 0
              ) {
                msg = msg + "<br>This is part of the following ";
                msg =
                  response.report_definitions.length > 1
                    ? msg + "Report Definitions: "
                    : msg + "Report Definition: ";
                response.report_definitions.forEach((item, index) => {
                  reports = reports + "records=" + item.id + "&";
                  msg =
                    msg +
                    "<br><b>" +
                    (index + 1) +
                    ". " +
                    item.report +
                    " (" +
                    item.valid_from +
                    " - " +
                    item.valid_to +
                    ") " +
                    item.status +
                    "</b> ";
                });
              }
              msg =
                msg +
                "<br> Are you sure you want to go ahead? If yes, all affected Report Definitions will go back to status “draft” ";
              reports =
                reports + "record_type=scope&record_id=" + editObject.id;
              this.$buefy.dialog.confirm({
                title: "Warning!",
                message: msg,
                type: "is-danger",
                ariaRole: "alertdialog",
                ariaModal: true,
                confirmText: "Yes",
                onConfirm: () => this.updateReportDefinition(reports)
              });
            } else {
              this.$buefy.toast.open("Scope deleted!");
              this.data = [];
              this.fetchScopeData(this.query);
            }
          },
          e => {
            this.handleApiError(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.handleApiError(e);
        this.isDataLoading = false;
      }
    },
    updateReportDefinition(params) {
      try {
        this.RulesManagerService.updateReportDefinition(params).subscribe(
          () => {
            this.$buefy.toast.open("Scope deleted!");
            this.data = [];
            this.fetchScopeData();
          },
          e => {
            this.handleApiError(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.handleApiError(e);
        this.isDataLoading = false;
      }
    },
    clickEditScope(editObject) {
      this.$router.push({
        path: `/rulesManager/scopeDefinition/${editObject.id}`
      });
    },
    clickViewScope(editObject) {
      this.$router.push({
        path: `/rulesManager/scopeDefinition/${editObject.id}/view`
      });
    }
  }
};
</script>
